<template>
    <layout-portal>
        <div class="profile-page">
            <div class="row no-gutters">
                <div class="col-sm-12">
                    <form autocomplete="off" @submit.prevent="saveItem" @keyup.enter="saveItem" method="post" data-vv-scope="form">
                        <div class="row mb-3">
                            <div class="col-sm-12">
                                <h1 class="content-title">{{ $t(subPageTitle) }}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-auto photos" v-if="form.id">
                                <div class="row h-100">
                                    <div class="col-4 col-sm-12 mx-auto mb-3 mb-sm-4">
                                        <div class="photo h-100">
                                            <!-- <img class="photo img-fluid" :src="getImageUser(form.photo)"> -->
                                            <upload-multiple-image
                                                :disabled="readonlyFormItem"
                                                ref="uploadImage"
                                                :enableMainImage="true"
                                                :showImageLimitMessage="false"
                                                v-model="photos"
                                                :maxImage="1"
                                                :multiple="false"
                                                :noOverlay="true"
                                                name="photos"
                                                v-validate="''"
                                                :showDeleteButton="false"
                                                :showEditButton="false">
                                            </upload-multiple-image>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div class="col-sm">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <MaterialInput
                                            autocomplete="new-name"
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-name"
                                            name="name"
                                            v-model.trim="form.name"
                                            v-validate="'required|min:3'"
                                            :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                            :error=" fnFirstError('name')">
                                            {{ $t(`${pageID}.model.name`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <MaterialInput
                                            autocomplete="new-email"
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            type="email"
                                            class="city-form-group city-bg"
                                            id="input-email"
                                            name="email"
                                            v-model.trim="form.email"
                                            v-validate="'required|email'"
                                            :inputClasses="[{'is-invalid': fnHasError('email') }]"
                                            :error=" fnFirstError('email')">
                                            {{ $t(`${pageID}.model.email`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <MaterialInput
                                    autocomplete="new-phone"
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-phone"
                                    name="phone"
                                    v-model.trim="form.phone"
                                    v-validate="'numeric|min_value:1|min:9|max:14'"
                                    :inputClasses="[{'is-invalid': fnHasError('phone') }]"
                                    :error=" fnFirstError('phone')">
                                    {{ $t(`${pageID}.model.phone`) }}
                                </MaterialInput>
                            </div>
                            <div class="col-sm-6">
                                <MaterialInput
                                    autocomplete="new-nif"
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-nif"
                                    name="nif"
                                    v-model.trim="form.nif"
                                    v-validate="'digits:9|min_value:1'"
                                    :inputClasses="[{'is-invalid': fnHasError('nif') }]"
                                    :error=" fnFirstError('nif')">
                                    {{ $t(`${pageID}.model.nif`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="row" v-if="!readonlyFormItem">
                            <div class="col-sm-4">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialInput
                                        autocomplete="new-password"
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        type="password"
                                        class="city-form-group city-bg"
                                        id="input-old_password"
                                        name="old_password"
                                        v-model.trim="form.old_password"
                                        v-validate="{min: 6}"
                                        ref="old_password"
                                        :inputClasses="[{'is-invalid': fnHasError('old_password')}]"
                                        :error="fnFirstError('old_password')">
                                        {{ $t(`${pageID}.model.old_password`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialInput
                                        autocomplete="new-password"
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        type="password"
                                        class="city-form-group city-bg"
                                        id="input-new_password"
                                        name="new_password"
                                        v-model.trim="form.new_password"
                                        v-validate="{required: form.old_password!=null, min: getMinPasswordLength()}"
                                        ref="new_password"
                                        :inputClasses="[{'is-invalid': fnHasError('new_password')}]"
                                        :error="fnFirstError('new_password')">
                                        {{ $t(`${pageID}.model.new_password`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialInput
                                        autocomplete="new-password"
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        type="password"
                                        class="city-form-group city-bg"
                                        id="input-new_password_confirmation"
                                        name="new_password_confirmation"
                                        v-model.trim="form.new_password_confirmation"
                                        v-validate="{required: form.old_password!=null, confirmed: 'new_password'}"
                                        :inputClasses="[{'is-invalid': fnHasError('new_password_confirmation')}]"
                                        :error="fnFirstError('new_password_confirmation')"
                                        data-vv-as="new_password">
                                        {{ $t(`${pageID}.model.new_password_confirmation`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>
                        <buttons-footer
                            :enableButtons="!readonlyFormItem"
                            :isDisabled="isDisabled"
                            @save="saveItem"
                            @cancel="handleBack(`${moduleCode}.dashboard`)"
                        >
                            <button v-if="!readonlyFormItem"
                                class="btn btn-outline-tertiary btn-rounded btn-responsive btn-md btn-block z-depth-0"
                                type="button"
                                @click.prevent="triggerFile">
                                {{ $t(photoTitle) }}
                            </button>
                        </buttons-footer>
                    </form>
                </div>
            </div>
        </div>
    </layout-portal>
</template>

<script>
    import GeneralMixin from '../mixin'
    import { formatUrl } from "@config/utils";

    export default {
        mixins: [
            GeneralMixin
        ],
        components: {
            UploadMultipleImage: () => import(/* webpackChunkName: "upload-image" */ '@/components/form/UploadMultipleImage'),
        },
        data() {
            let pageID = 'profile';
            return {
                loaded: false,
                pageID: pageID,
                subPageTitle: `${pageID}.sub_title`,
                photoTitle: `${pageID}.buttons.edit_photo`,
                form: {
                    id: null,
                    name: null,
                    email: null,
                    phone: null,
                    nif: null,
                    old_password: null,
                    new_password: null,
                    new_password_confirmation: null,
                    photo: null
                },
                photos: [],
            }
        },
        mounted() {
            this.loadItem();
        },
        methods: {
            triggerFile: function() {
                if (this.$refs.uploadImage) {
                    this.$refs.uploadImage.triggerInput();
                }
            },
            forceDirtyPhotos: function() {
                if(this.fields.$form && this.fields.$form['photos']){
                    this.fields.$form['photos'].dirty=true;
                }
            },
            loadItem: function() {
                let httpOptions = {
                };
                this.$http.get(formatUrl(this.url.show, {id: this.form.id}), httpOptions)
                .then(res => {
                    this.form = Object.assign(this.form, res.data.data);
                    this.photos = this.form.photo ? [{path: this.form.photo}] : [];
                    this.loaded = true;
                })
                .catch(error => {
                    this.showHttpError(error);
                })
            },
            saveItem: function() {
                var app = this;
                this.clearMessages();

                this.$validator.validateAll('form').then(result => {
                    if(!result){
                        this.showMessage(this.$t(`global.msg.error.form`), this.pageTitle, 'error');
                        return;
                    }

                    let formData = new FormData();
                    formData.append('_method', 'PUT');
                    formData.append('id', app.form.id);
                    formData.append('name', app.form.name);
                    formData.append('phone', app.form.phone ? app.form.phone : '');
                    formData.append('email', app.form.email ? app.form.email : '');
                    formData.append('nif', app.form.nif ? app.form.nif : '');
                    formData.append('password', app.form.old_password ? app.form.old_password : '');
                    formData.append('new_password', app.form.new_password ? app.form.new_password : '');
                    formData.append('new_password_confirmation', app.form.new_password_confirmation ? app.form.new_password_confirmation : '');
                    // formData.append('photo', app.form.photo);
                    if(this.photos.length>0){
                        for (var p = 0, len=this.photos.length; p<len; p++)
                        {
                            if(this.photos[p].file){
                                formData.append("photo", this.photos[p].file);
                                break;
                            }
                        }
                    }

                    let httpOptions = {
                        'Content-Type': 'multipart/form-data'
                    };
                    this.$http.post(this.url.update.replace(':id', this.form.id), formData, httpOptions)
                    .then( res => {
                        this.$auth.fetch(
                        {
                            success: () =>
                            {
                                this.showMessage(res.data.data);
                            },
                            error: error =>
                            {
                                this.showHttpError(error);
                            }
                        });
                    })
                    .catch( error => {
                        this.showHttpError(error);
                    })
                });
            }
        },
        watch:{
            'photos': {
                handler(value, oldValue){
                    if(!this.loaded){
                        return;
                    }
                    this.forceDirtyPhotos();
                },
                deep: true,
            },
        }
    }
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
.photos {
    @include sm {
        .photo {
            width: 175px;
        }
    }

}
</style>

